import { Navigate } from 'react-router-dom'
import { getAuthGuardRedirect } from '@/app/authNavigation'
import { Spinner } from '@/components/ui'
import { useAuth } from '@/hooks/useAuth'

interface AuthGuardProps {
  children: React.ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { estaAutenticado, cargando, usuario } = useAuth()
  const redirectTo = getAuthGuardRedirect({ cargando, estaAutenticado, usuario })

  if (cargando) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-950">
        <div className="flex flex-col items-center gap-3">
          <Spinner tamano="lg" className="text-teal-400" />
          <p className="text-sm text-gray-500">Cargando RadCore AI…</p>
        </div>
      </div>
    )
  }

  if (redirectTo) return <Navigate to={redirectTo} replace />

  return <>{children}</>
}
